import _helper from "actions/helper";

const obj = {
    setup(e, itemClass, cb) {
        const { clientY, target } = e;

        const rowNode = _helper.dom.getParentByClass(target, itemClass);
        const index = _helper.dom.getChildIndex(rowNode);

        _helper.dom.addClass(rowNode, "globMovingItem");

        this.stratCoords = { clientY, rowNode, index };

        _helper.disconnect(this.tempEvents);
        this.tempEvents = [];
        this.tempEvents.push(_helper.on(window, "mousemove", this.onMoving.bind(this)));
        this.tempEvents.push(_helper.on(window, "mouseup", this.onEnd.bind(this, cb)));
    },

    onMoving(e) {
        const { clientY, rowNode } = this.stratCoords;
        const diffY = e.clientY - clientY;
        const node = diffY > -1 ? rowNode.nextElementSibling : rowNode.previousElementSibling;

        if (!node) {
            _helper.dom.styleProp(rowNode, "moved", "");
            return;
        }

        node.parentNode.scrollTop = diffY;

        const y = rowNode.offsetTop + diffY;
        const toY = node.offsetTop;

        let changeTo = "";
        if (diffY > 0 && y >= toY)
            changeTo = "after";
        else if (diffY < 0 && y <= toY)
            changeTo = "before";

        if (changeTo) {
            _helper.dom.place(rowNode, node, changeTo);
            _helper.dom.styleProp(rowNode, "moved", 0);
            this.stratCoords.clientY = e.clientY;

            return;
        }

        _helper.dom.styleProp(rowNode, "moved", diffY);
    },

    onEnd(cb) {
        const { rowNode, index } = this.stratCoords;

        _helper.disconnect(this.tempEvents);

        _helper.dom.removeClass(rowNode, "globMovingItem");
        _helper.dom.styleProp(rowNode, "moved", "");

        const currIndex = _helper.dom.getChildIndex(rowNode);
        if (currIndex !== index && cb?.apply)
            cb(currIndex);
    }
};

export default obj;
